import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { WebAuthService } from './auth.service';

function isPublicRequest(url: string, method: string): boolean {
  if (method.toUpperCase() !== 'GET') {
    return false;
  }

  let pathname = url;
  try {
    const base =
      typeof window !== 'undefined' && window.location?.origin ? window.location.origin : 'http://localhost';
    pathname = new URL(url, base).pathname;
  } catch {
    pathname = url;
  }

  return (
    pathname.includes('/public/') ||
    pathname.endsWith('/events') ||
    pathname.includes('/events/public/') ||
    /\/events\/[^/]+\/sectors$/.test(pathname) ||
    /\/events\/[^/]+\/batches$/.test(pathname)
  );
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(WebAuthService);
  const token = auth.getToken();
  if (!token || isPublicRequest(req.url, req.method)) return next(req);

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
};
